<template>
        <div style="width: 100%;height:100%;padding:60px 20px;">
          <p class="P1"><span class="T1">更新于2023年1月30日</span></p>
          <p class="P4"><span class="T2">以下隐私条款是加加互动（厦门）体育产业有限公司（以下称“加加”或“我们”）对用户隐私保护的许诺，请您务必仔细阅读，以了解我们关于管理您个人信息的情况。本隐私条款属于“加加互动（厦门）体育产业有限公司用户服务条款”的重要组成部分，与其具有同等法律效力。本条款包括以下内容：</span></p>
          <p class="P2"><span class="T5">1. 概述</span></p>
          <p class="P4"><span class="T2">加加互动（厦门）体育产业有限公司为ijustjump.com的域名所有人及Loop App的所有者及运营者，我们有义务尊重任何访问本网站人员的隐私。本条款旨在告知您我们关于收集、使用和披露您通过网站及Loop App提交给我们的任何个人信息和匿名信息的政策和行为规范。</span></p>
          <p class="P4"><span class="T2">“个人信息”是指您通过Loop网站或Loop App上传的个人信息，包括但不限于姓名、地址、电子邮件地址、手机号码、社交账号、个人通过App采集的GPS定位数据及运动数据信息，以及与上述内容相关的其他非公开信息。”匿名信息”是指与您的个人信息无关或无联系的信息；匿名信息不允许透露个人身份。</span></p>
          <p class="P4"><span class="T2">查看和访问www.ijustjump.com网站（本“网站”）、下载Loop App（App）即表示您已阅读、理解并同意本隐私条款全文。如果您不同意本隐私条款的所有内容，您的唯一且独有的补救措施就是立即停止使用本网站或App。</span></p>
          <p class="P4"><span class="T2">针对您使用本网站、App适用的条款和条件包括在单独的服务条款中，请访问（“服务条款”）</span><a href="https://s.loopsports.cn/service" class="Internet_20_link"><span class="Internet_20_link"><span class="T7">查看</span></span></a><span class="T2">。</span></p>
          <p class="P2"><span class="T5">2. 用户同意</span></p>
          <p class="P4"><span class="T2">通过本网站或App提交个人信息，即表示您同意本隐私条款并明确同意按照本条款约定对您的个人信息进行处理。我们对您个人信息的处理可能在收集信息的所在国进行，也可能在其他国家进行，但无论如何，我们都会严格遵守信息处理国当地关于处理个人信息相关法律法规。</span></p>
          <p class="P4"><span class="T2">从您那里收集的个人信息帮助我们提供App里面数据的展示，有助于我们了解网站访客、我们的用户和潜在用户。通过使用这些信息，我们更好地优化我们产品并为服务功能的升级提供更好的支持，从而为您提供更好的服务。</span></p>
          <p class="P2"><span class="T5">3. 我们收集的信息</span></p>
          <p class="P4"><span class="T2">1）您向我们提供的个人信息</span></p>
          <p class="P4"><span class="T2">当您成为Loop App的注册用户时，我们会收集您的手机号码、社交账号信息等；当您使用Loop App进行训练时，我们会收集您的身高、体重、健康数据等；当您回复我们的用户满意度调查时，我们会收集您的姓名和电子邮件地址；当您使用Loop App上传运动数据给我们时，我们会收集您的相关个人信息和运动数据；当您在Loop商城下单购物时，我们会收集收货人姓名、地址及电话等信息。</span></p>
          <p class="P4"><span class="T2">2）凭借技术收集的个人信息</span></p>
          <p class="P4"><span class="T2">当您浏览本网站或App时，某些信息可能也会被动收集，包括您的网络通信协议地址（“IP地址”）、浏览器类型、域名、访问时间以及操作系统等。我们也会使用“Cookies”和包括统一资源定位器（URL）在内的导航数据，来收集您的访问日期和时间，以及您搜索和浏览的信息。收集这些类型的信息可以让我们的产品和服务为您提供更有针对性的帮助。在我们向您发送的电子邮件中，有的会包含“点击URL”，基于方便您的考虑，当您点击这些URL时，您将通过我们的网络服务器到达目标网站。通过追踪点击率，能帮助我们确定您对特定主题的兴趣，还能帮助我们衡量发送用户通信的有效性。</span></p>
          <p class="P4"><span class="T2">“IP地址”是在您使用网络时向您的电脑自动分配的数字。在某些情况下，您的IP地址在浏览不同会话时是保持不变的；但是如果您使用的是消费者网络访问提供商，您的IP地址在不同会话时可能不同。我们仅追踪和会话Cookies相连的IP地址，用来分析我们网站的流量情况。</span></p>
          <p class="P4"><span class="T3">“</span><span class="T4">手机设备信息，如MAC信息，设备ID, ANDROID ID等”是跳绳后收集您的手机信息用于分析您使用跳绳和App时遇到的问题，用于解决这些问题所需要收集的。</span></p>
          <p class="P4"><span class="T2">“Cookies”是在您浏览一个网站时，网站向您的电脑硬盘驱动器发送的一个小型信息片段。我们可能使用会话Cookies（一旦关闭网页浏览器便会失效）和持久性Cookies（会一直保存在您的电脑上直到您删除它们），从而向您提供更加私人化和更具互动性的网站体验。按照网络浏览器帮助文件指南，您就能删除持久性Cookies。如果您选择禁用Cookies，网站的某些区域可能不会正常工作。</span></p>
          <p class="P4"><span class="T2">3）从其他资源得到的个人信息</span></p>
          <p class="P4"><span class="T2">我们可能通过包括邮件、电话或传真在内的其他资源获得您的个人信息。我们可能将这些信息与我们已通过本网络收集的您的信息合并在一起，从而改进我们提供的产品和服务。</span></p>
          <p class="P4"><span class="T2">4）用户反馈</span></p>
          <p class="P4"><span class="T2">如果您在本网站上向我们提供反馈，对于反馈中包含的您的个人信息，我们亦会按照本条款的约定进行保密，我们也将利用这些反馈信息来更好的提升我们的产品及服务。</span></p>
          <ol>
            <li>
              <p class="P5" style="margin-left:0cm;"><span style="display:block;float:left;min-width:NaNcm;">5)</span><span class="T4">剪贴板</span><span class="odfLiEnd"> </span></p>
            </li>
          </ol>
          <p class="P6"><span class="T4">我们会收集您剪贴板上的内容以方便您通过邀请码进入到相应的竞赛或者小组之中。</span></p>
          <p class="P2"><span class="T5">4. 信息使用</span></p>
          <p class="P4"><span class="T2">如果您选择接收我们发送的以下通信，您提交给我们的个人信息可能被用于回复您的请求、向您发送新闻通讯、一般的信息公告，以及与我们或我们的产品相关的其他信息，或帮助我们为您提供更好的服务。</span></p>
          <p class="P4"><span class="T2">对于我们发送的信息，您享有随时退订的权利。在我们发送给您的每封电子邮件或每条手机短信底部，您都有机会选择停止接收我们发送的更多通信。</span></p>
          <p class="P4"><span class="T2">为了提升服务品质，我们可能会与第三方服务商合作，继而会允许第三方接触到您的个人信息。但在此种情形下，只有该第三方同意承担与我们同等的保护用户隐私的责任，我们才会将用户相关信息提供。我们可能根据您的个人信息创建匿名信息，匿名信息里面不包括可识别您个人身份的信息（如您的姓名）。我们可能利用匿名信息来分析请求模式和使用模式，从而提高我们的产品和服务。</span></p>
          <p class="P4"><span class="T2">我们保留自行选择向第三方使用和披露上述匿名信息的权利，包括用于内部业务分析，以及向我们的各个合作方提供汇总统计数据等，但这些数据均以“统计数据”且匿名的形式出现，而不会泄露您的个人信息。</span></p>
          <p class="P2"><span class="T5">5. 个人信息披露</span></p>
          <p class="P4"><span class="T2">除非本隐私条款另有说明，否则我们通常不会向第三方交换、出租或共享您的个人信息。除非您提出要求或得到您的书面允许。</span></p>
          <p class="P4"><span class="T2">基于处理付款、货物配送或帮助您访问本站的需要（如有些服务需要我们与第三方服务商同时向您提供服务），我们可能向第三方共享您的个人信息。除非提供服务的需要，否则这些第三方不得使用您的个人信息，且他们使用您的个人信息的行为受到相关保密协议的约束。</span></p>
          <p class="P4"><span class="T2">目前我们不会与我们的关联公司（包括但不限于我们的母公司、子公司以及其他与我们有关联关系的公司）共享您的个人信息；但是将来如果我们要与这些附属公司共享您的部分或全部个人信息，我们会要求他们遵守本隐私条款。</span></p>
          <p class="P4"><span class="T2">除非本隐私政策中另有说明，经过您的允许或者在以下情况下，否则我们不会与第三方分享您的个人信息。</span></p>
          <p class="P4"><span class="T2">（1） 服务要求披露。我们会向帮助提供服务的有关人员披露个人信息，包括执行技术、管理和数据处理任务（如托管、计费、实施、数据存储和安全）的人员；</span></p>
          <p class="P4"><span class="T2">（2）法律要求或为了保护权利。如果法律要求，或者为了响应传票或法院指令，或者当我们单方面有合理的理由认为为了保护Loop、第三方或一般大众的财产或权利必须进行披露时，我们将披露个人信息。</span></p>
          <p class="P4"><span class="T2">（3）业务转让、破产。如果进行合并、收购或破产或者销售我们的部分或全部资产，我们有权将拥有的所有个人信息转让给接任的组织。除了破产或其它法院指定的范围，使用和披露所有转让的个人信息将受本隐私条款的约束，如果您被通知将出台新的隐私条款，本隐私条款有可能停止，则使用和披露行为受新隐私条款的约束。但是，转让后提交或收集的个人信息须遵守Loop的接任组织制定的新隐私条款或政策。</span></p>
          <p class="P4"><span class="T2">您在本网站或Loop App内发布信息时，应严格遵守相关规定，如果我们发现您发布法律、法规禁止发布或者传输的信息，我们有权立即停止传输该信息，采取消除等处置措施，保存有关记录，并向有关主管部门报告。</span></p>
          <p class="P4"><span class="T2">如果有其他客户发现您发布的信息泄露个人身份、散布个人隐私等侵害其合法权益，或您如在我们许可的情况下发布商业性电子信息，而其他客户表示遭受侵扰，这些客户有权要求我们删除您发布的信息，或者采取其他必要措施予以制止。我们将会依法采取这些措施。</span></p>
          <p class="P4"><span class="T2">（4）您可以自行在“我的”页面点击设置，在“意见与反馈”页面选择“其他”提交账户注销申请，我们会根据具体您的情况在3~5个工作日内注销您需要注销的账号及信息。</span></p>
          <p class="P4"><span class="T2">（5）在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span></p>
          <p class="P4"><span class="T3">（6）第三方SDK收集使用信息说明</span></p>
          <p class="P4"><span class="T3">为保障我们服务的稳定运行或实现相关功能，我们可能会接入由我们的关联第三方和/或授权合作第三方提供的软件开发包（SDK）实现前述目的。我们会尽到审慎义务，对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。</span></p>
          <p class="P4"><span class="T3">我们接入的第三方SDK主要服务于您以及其他的用户的需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK。我们会及时在本说明中向您公开说明接入第三方SDK的最新情况。目前我们接入的第三方SDK列明如下：</span></p>
          <p class="P4"><span class="T3">腾讯</span></p>
          <p class="P4"><span class="T3">功能：提供安全认证服务收集个人信息类型：您的设备型号、操作系统、设备Mac地址、唯一设备标识符（例如IMEI、AndroidID、ICCID、IMSI）、应用列表、登录IP地址、QQ软件版本号、接入网络的方式、类型和状态，目的：方便用户登录，分享应用内容，第三方隐私政策链接：</span><a href="https://cloud.tencent.com/document/product/301/11470" class="Internet_20_link"><span class="Internet_20_link"><span class="T8">点击查看</span></span></a></p>
          <p class="P4"><span class="T3">微信</span></p>
          <p class="P4"><span class="T3">功能：提供安全认证服务收集个人信息类型：设备标识，网络状态，设备的IME，目的：方便用户登录，分享应用内容，第三方隐私政策链接：</span><a href="https://pay.weixin.qq.com/index.php/core/home/pay_pact_v4" class="Internet_20_link"><span class="Internet_20_link"><span class="T8">点击查看</span></span></a></p>
          <p class="P4"><span class="T4">微博</span></p>
          <p class="P4"><span class="T3">功能：提供安全认证服务收集个人信息类型：设备标识，网络状态，设备的IME，目的：方便用户登录，分享应用内容，第三方隐私政策链接：</span><a href="https://www.weibo.com/signup/v5/privacy" class="Internet_20_link"><span class="Internet_20_link"><span class="T8">点击查看</span></span></a></p>
          <p class="P2"><span class="T5">6.您的选择</span></p>
          <p class="P4"><span class="T2">在收集、使用和共享您的个人信息方面，我们为您提供多个选择。当您通过本网站或Loop App进行课程训练或者下单购物时，您可以选择接收我们发送的课程及促销资讯。您可以注明希望停止接收我们发送的更多资讯，而且您将有机会“退订”，方法是按照您收到的电子邮件或手机短信中的取消订阅说明进行操作，或者直接联系我们（请查看下方的联系信息）来取消订阅。尽管您注明了您的电子邮件或手机短信偏好，我们可能还是会向您发送我们认为重要的信息。</span></p>
          <p class="P2"><span class="T5">7. 其他网站</span></p>
          <p class="P4"><span class="T2">基于本站及Loop App运营考虑和需要，我们可能会向您提供任何其他网站或地址的链接，这样做旨在为您提供方便，不表示我们认可这些网站或地址或其内容。我们不会控制、审查这些外部网站或其内容，亦不对其承担责任。请注意，我们的隐私条款的条款并不适用于这些外部网站。</span></p>
          <p class="P2"><span class="T5">8. 联系我们</span></p>
          <p class="P4"><span class="T2">如果您对本隐私条款有任何疑问或疑虑，请通过4008-696-916联系我们。</span></p>
          <p class="P2"><span class="T5">9. 隐私条款更新</span></p>
          <p class="P4"><span class="T2">根据国家法律法规的更新及网站运营需要，我们有权对本条款不时地进行修改，修改后的隐私条款一旦被张贴在本站上即生效力，并代替原来的隐私条款。您可随时登录查阅最新隐私条款内容。如您不同意更新后的隐私条款，应立即停止接受本站提供的服务；如您继续使用本站提供的服务，即视为同意更新后的隐私条款。我们建议您在使用本站之前阅读本隐私条款及本站的公告。如果本条款中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span></p>
          <p class="Standard"> </p>
        </div>
      </template>
      
      <script>
      export default {
        data: function () {
          return {};
        },
        mounted() {},
      };
      </script>
      
      <style type="text/css">
      @page {
      }
      
      table {
        border-collapse: collapse;
        border-spacing: 0;
        empty-cells: show;
      }
      
      td,
      th {
        vertical-align: top;
        font-size: 12pt;
      }
      
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        clear: both;
      }
      
      ol,
      ul {
        margin: 0;
        padding: 0;
      }
      
      li {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      
      /* "li span.odfLiEnd" - IE 7 issue*/
      li span {
        clear: both;
        line-height: 0;
        width: 0;
        height: 0;
        margin: 0;
        padding: 0;
      }
      
      span.footnodeNumber {
        padding-right: 1em;
      }
      
      span.annotation_style_by_filter {
        font-size: 95%;
        font-family: Arial;
        background-color: #fff000;
        margin: 0;
        border: 0;
        padding: 0;
      }
      
      span.heading_numbering {
        margin-right: 0.8rem;
      }
      
      * {
        margin: 0;
      }
      
      .P1 {
        font-size: 24pt;
        font-weight: bold;
        margin-bottom: 0.1945in;
        margin-top: 0in;
        text-align: left !important;
        font-family: 宋体;
        writing-mode: horizontal-tb;
        direction: ltr;
        margin-left: 0in;
        margin-right: 0in;
        text-indent: 0in;
        padding: 0in;
        border-style: none;
      }
      
      .P2 {
        font-size: 13.5pt;
        font-weight: bold;
        margin-bottom: 0.1945in;
        margin-top: 0.1945in;
        text-align: left !important;
        font-family: 宋体;
        writing-mode: horizontal-tb;
        direction: ltr;
        margin-left: 0in;
        margin-right: 0in;
        text-indent: 0in;
        padding: 0in;
        border-style: none;
      }
      
      .P3 {
        font-size: 12pt;
        margin-bottom: 0in;
        margin-left: 0in;
        margin-right: 0in;
        margin-top: 0in;
        text-align: left !important;
        text-indent: 0in;
        font-family: Calibri;
        writing-mode: horizontal-tb;
        direction: ltr;
        padding: 0in;
        border-style: none;
      }
      
      .Standard {
        font-size: 10.5pt;
        font-family: Calibri;
        writing-mode: horizontal-tb;
        direction: ltr;
        text-align: justify !important;
      }
      
      .Internet_20_link {
        color: #0000ff;
        text-decoration: underline;
      }
      
      .T1 {
        color: #999999;
        font-family: Helvetica Neue Light;
        letter-spacing: normal;
        font-style: normal;
      }
      
      .T2 {
        color: #666666;
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0043in;
        font-style: normal;
      }
      
      .T3 {
        color: #666666;
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0043in;
        font-style: normal;
      }
      
      .T4 {
        color: #666666;
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0043in;
        font-style: normal;
      }
      
      .T5 {
        color: #333333;
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0047in;
        font-style: normal;
        font-weight: bold;
      }
      
      .T6 {
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0043in;
        font-style: normal;
      }
      
      .T7 {
        font-family: Helvetica Neue Light;
        letter-spacing: -0.0043in;
        font-style: normal;
      }
      </style>
      